module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAABGdBTUEAALGPC/xhBQAAAQJJREFUOBHlUkEOgjAQpJB45+hTuPkHEz5A4OaDgPAXT/ITfQMkBGcI28hqq/TqJEO7uzMbmBBFflQYk0HI4BpW8r4LR6jv4LySd/Z+wgGqGyhmOdnj7CtqKMSkT868qDDVJl1T8xEZugOoDbqmhtoNjqjuoBa7amrpWXDA8wa6xK4+PfRGdYBZltL79zA1gBSqwCSaOE3TC8x9wIKe3jjP8xHmM/jYsYTaM71GTF3XZdM0Xed5Xn4O6evTGDMmSXIqimJ561gEbGDIz/GCGjFTaBewKMuywUG60KwaO98sYNcT6hKada6XtwWOUG1oeoENUQ8kVPZfQ9M6b922bUX6RE/IJoeMFMmZlAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/button_filter_sorting_asc_8_12.png
// module id = ./src/_asset/sources/assets/images/button_filter_sorting_asc_8_12.png
// module chunks = main